import React from 'react'
import { useQuery } from 'react-query'
import { useParams, useHistory } from 'react-router-dom'
import { Container, Spinner } from 'react-bootstrap'

import { useApi, useBreakpoint } from '../../../hooks'
import useAppContext from '../../app'
import VehicleHeader from './VehicleHeader'
import AdasSections from './AdasSections'
import MechanicalSection from './MechanicalSection'
import SafetyFeatures from './SafetyFeatures'

import './adasReportDetail.css'

const AdasReportDetail = () => {
  const { id } = useParams()
  const history = useHistory()
  const { adasReportService } = useApi()
  const { store: { clientSettings, isLog } } = useAppContext()
  const { BREAKPOINT, screenBiggerThan } = useBreakpoint()
  const isBiggerThanXL = screenBiggerThan(BREAKPOINT.XL)

  const defaultAllowViewPricing = clientSettings && clientSettings.vehicleReports && clientSettings.vehicleReports.allowViewPricing
  let allowViewPricing = defaultAllowViewPricing
  if (!isLog) {
    const token = localStorage['access_token']
    const payload = token ? JSON.parse(window.atob(token.split('.')[1])) : null
    if (typeof payload?.pricing === 'boolean') allowViewPricing = payload.pricing
  }

  const { isLoading, isError, data: reportResult, refetch } = useQuery(
    ['adasReport', id],
    () => adasReportService.get(id),
    { refetchOnWindowFocus: false }
  )

  const report = reportResult && reportResult.vehicleReport
  const allowViewPricingByReport = reportResult && typeof reportResult.allowViewPricing === 'boolean'
    ? reportResult.allowViewPricing
    : allowViewPricing

  const handleBack = () => {
    history.push('/adas-reports')
  }

  if (isLoading) {
    return (
      <Container fluid={!isBiggerThanXL} className='my-5 text-center'>
        <Spinner animation='border' />
      </Container>
    )
  }

  // Fetch finished but the report couldn't be loaded (not found, not owned, or
  // a server error). Show an actionable message instead of an endless spinner.
  if (isError || !report) {
    return (
      <Container fluid={!isBiggerThanXL} className='my-5 text-center'>
        <div className='adas-detail__top-bar'>
          <button type='button' className='adas-detail__back' onClick={handleBack} aria-label='Back to Reports'>
            <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path d='M15 19L8 12L15 5' stroke='#000000' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            </svg>
          </button>
        </div>
        <p className='mt-4 mb-3'>We couldn&apos;t load this report. It may still be processing, or you may not have access to it.</p>
        <button className='btn btn-outline-primary' onClick={() => refetch()}>Try again</button>
      </Container>
    )
  }

  return (
    <Container fluid={!isBiggerThanXL} className='adas-report-detail'>
      <div className='adas-detail__top-bar'>
        <button type='button' className='adas-detail__back' onClick={handleBack} aria-label='Back to Reports'>
          <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M15 19L8 12L15 5' stroke='#000000' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
          </svg>
        </button>
      </div>

      <div className='adas-detail__content'>
        <VehicleHeader report={report} allowViewPricing={allowViewPricingByReport} refetch={refetch} />
        <SafetyFeatures report={report} />
        <AdasSections report={report} allowViewPricing={allowViewPricingByReport} />
        <MechanicalSection report={report} allowViewPricing={allowViewPricingByReport} />
      </div>
    </Container>
  )
}

export default AdasReportDetail
